import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamoFinanciamientoComponent () {
  var $ctrl = this

  $ctrl.generandoPagos = false
  $ctrl.generarPagos = generarPagos

  function generarPagos (financiamiento) {
    if ($ctrl.generandoPagos === false) {
      $ctrl.generandoPagos = true

      return
    }

    $ctrl.generandoPagos = false

    if (financiamiento) {
      $ctrl.data.financiamiento = financiamiento
    }
  }
}

module.component('financesPosicionbancariaPrestamoFinanciamiento', {
  controller: FinancesPosicionbancariaPrestamoFinanciamientoComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamo/financiamiento/component.js